import React from "react";
import { Check } from "lucide-react";

export default function About({ business, contact }) {
    if (!business) return null;
    return (
        <section id="about" className="relative bg-[#0a0a0a] border-t border-zinc-900 overflow-hidden">
            <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
                    <div className="lg:col-span-5">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="h-px w-10 bg-yellow-400" />
                            <span className="font-mono-accent text-[11px] text-yellow-400">
                                03 / About
                            </span>
                        </div>
                        <h2
                            data-testid="about-heading"
                            className="font-display text-white text-5xl md:text-6xl lg:text-7xl"
                        >
                            {business.about_title}
                        </h2>
                        <p className="mt-8 text-zinc-400 text-base md:text-lg leading-relaxed">
                            {business.about_body}
                        </p>

                        <div className="mt-10 grid grid-cols-2 gap-4">
                            <div className="border border-zinc-800 p-5">
                                <div className="font-mono-accent text-[10px] text-yellow-400 mb-2">
                                    SERVICE AREAS
                                </div>
                                <div className="text-white text-sm leading-relaxed">
                                    {contact?.service_area}
                                </div>
                            </div>
                            <div className="border border-zinc-800 p-5">
                                <div className="font-mono-accent text-[10px] text-yellow-400 mb-2">
                                    HOURS
                                </div>
                                <div className="text-white text-sm">{contact?.hours}</div>
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-7">
                        <div className="grid sm:grid-cols-2 gap-px bg-zinc-900 border border-zinc-900">
                            {business.why_us?.map((w, i) => (
                                <div
                                    key={i}
                                    data-testid={`why-us-${i}`}
                                    className="bg-[#050505] p-6 md:p-8 flex items-start gap-4 hover:bg-[#111] transition-colors group"
                                >
                                    <div className="w-8 h-8 border border-yellow-400 flex items-center justify-center shrink-0 group-hover:bg-yellow-400 transition-colors">
                                        <Check className="w-4 h-4 text-yellow-400 group-hover:text-black transition-colors" />
                                    </div>
                                    <div>
                                        <div className="font-mono-accent text-[10px] text-zinc-500 mb-1">
                                            REASON {String(i + 1).padStart(2, "0")}
                                        </div>
                                        <div className="text-white font-semibold text-base md:text-lg leading-snug">
                                            {w}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
